module.exports = __webpack_public_path__ + "media/images/workplace/patterns/1-44d4295471f29f8df20becc9b768dc05.png";